import { useNotify } from "react-admin";
import {
  IReport,
  IReportContext,
  IReportContextAccessor,
  IReportContextAction,
  REMOVE_REPORT,
} from "./context";
import { Dispatch } from "react";

export class ReportContextAccessor implements IReportContextAccessor {
  private dispatch: Dispatch<IReportContextAction>;
  private notify: ReturnType<typeof useNotify>;
  readonly generatedReports: Map<string, IReport>;
  readonly accessor = this;

  constructor(
    dispatch: Dispatch<IReportContextAction>,
    state: IReportContext,
    notify: ReturnType<typeof useNotify>
  ) {
    this.dispatch = dispatch;
    this.generatedReports = state.generatedReports;
    this.notify = notify;
  }

  getReport = (reportName: string) => {
    const report = this.generatedReports.get(reportName);
    if (!report) {
      return undefined;
    }

    this.removeReport(report);
    return report;
  };

  private removeReport = (report: IReport) => {
    this.dispatch({ type: REMOVE_REPORT, payload: report });
  };
}
